<template>
  <div>
    <DxPopup
      :visible="enabledPopUpIrrigation"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :on-hidden="onHidden"
      :show-title="true"
      :show-close-button="true"
      width="auto"
      height="auto"
      :title="$t('registerProject.registerProjectGreenHouse.title_groupItem_irrigation')"
    >
      <DxScrollView
        scroll-by-content
        scroll-by-thumb
        direction="both"
      >
        <div class="content-devx transparent scroll">
          <div class="row">
            <DxForm>
              <DxGroupItem
                :col-count="1"
              >
                <DxSimpleItem
                  :data-field="$t('registerProject.popPupIrrigation.nombre')"
                  :editor-options="{
                    onValueChanged: onChangeName,
                  }"
                >
                  <DxRequiredRule :message="$t('Field_Required')" />
                </DxSimpleItem>
                <DxSimpleItem
                  :data-field="$t('registerProject.popPupIrrigation.register_project_dropperFlowRate')"
                  :editor-options="{
                    onValueChanged: onChangeDropperFlowRate,
                  }"
                >
                  <DxRequiredRule :message="$t('Field_Required')" />
                </DxSimpleItem>
                <DxSimpleItem
                  data-field="LINEA DE GOTEROS"
                  editor-type="dxSelectBox"
                  :editor-options="{
                    items: ['SIMPLE', 'DOBLE'],
                    value: line,
                    onValueChanged: onChangeLine,
                    placeholder: ''
                  }"
                >
                  <DxRequiredRule :message="$t('Field_Required')" />
                </DxSimpleItem>
              </DxGroupItem>
              <DxGroupItem
                :visible="line==='SIMPLE'"
                :col-count="1"
                :caption="$t('registerProject.popPupIrrigation.line_simple')"
              >
                <DxSimpleItem
                  :data-field="$t('registerProject.popPupIrrigation.register_project_distanceBetweenLines')"
                  :editor-options="{
                    onValueChanged: onChangeDistanceBetweenLines,
                  }"
                />
                <DxSimpleItem
                  :data-field="$t('registerProject.popPupIrrigation.register_project_distanceBetweenDrippersIntoTheLine')"
                  :editor-options="{
                    onValueChanged: onChangeDistanceBetweenDrippersIntoTheLine,
                  }"
                />
              </DxGroupItem>
              <DxGroupItem
                :visible="line==='DOBLE'"
                :col-count="1"
                :caption="$t('registerProject.popPupIrrigation.line_double')"
              >
                <DxSimpleItem
                  :data-field="$t('registerProject.popPupIrrigation.distanceBetweenPairs')"
                  :editor-options="{
                    onValueChanged: onChangeDistanceBetweenPairs,
                  }"
                />
                <DxSimpleItem
                  :data-field="$t('registerProject.popPupIrrigation.distancewithinPairs')"
                  :editor-options="{
                    onValueChanged: onChangeDistancewithinPairs,
                  }"
                />
                <DxSimpleItem
                  :data-field="$t('registerProject.popPupIrrigation.register_project_distanceBetweenDrippersIntoTheLine')"
                  :editor-options="{
                    value: '',
                    onValueChanged: onChangeDistanceBetweenDrippersIntoTheLineDouble,
                  }"
                />
              </DxGroupItem>
            </DxForm>
            <div
              class="item-2"
            >
              <img
                class="imageIrrigation"
              >
              <p class="bold">
                {{ $t('registerProject.popPupIrrigation.example_text') }}
              </p>
            </div>
          </div>
        </div>
        <f7-block-footer
          class="content-action-botton"
        >
          <f7-button
            class="dx-btn-cancel margin-right"
            raised
            type="default"
            text-color="grey"
            styling-mode="outlined"
            name="ButtonCancel"
            @click="closePopUp"
          >
            {{ $t('EditOrder_ButtonCancel_caption') }}
          </f7-button>
          <f7-button
            :class="`dx-btn-success ${enabled ? '' : 'disabled'}`"
            raised
            type="success"
            styling-mode="contained"
            name="ButtonSave"
            @click="enabled ? followForm() : null"
          >
            {{ $t("EditOrder_ButtonSave_caption") }}
          </f7-button>
        </f7-block-footer>
      </DxScrollView>
    </DxPopup>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import { DxPopup } from 'devextreme-vue/popup';
import {
  DxForm, DxSimpleItem, DxGroupItem, DxRequiredRule,
} from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';

export default {
  name: 'IrrigationFormPopUp',
  components: {
    DxPopup,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
    DxScrollView,
  },
  data() {
    return {
      newIrrigation: {},
      enabled: false,
      line: '',
    };
  },
  computed: {
    ...mapState('ProjectGreenHouse', ['enabledPopUpIrrigation']),
  },
  methods: {
    validate() {
      this.enabled = !!(
        this.newIrrigation.name
          && this.newIrrigation.caudal
          && this.line
      );
    },
    onChangeName(e) {
      this.newIrrigation.name = e.value;
      this.validate();
    },
    onChangeDropperFlowRate(e) {
      this.newIrrigation.caudal = e.value;
      this.validate();
    },
    onChangeLine(e) {
      this.line = e.value;
      this.validate();
    },
    onChangeDistanceBetweenLines(e) {
      this.newIrrigation.simple_line_distance = e.value;
      this.validate();
    },
    onChangeDistanceBetweenDrippersIntoTheLine(e) {
      this.newIrrigation.simple_drip_distance = e.value;
    },
    onChangeDistanceBetweenPairs(e) {
      this.newIrrigation.pair_distance = e.value;
      this.validate();
    },
    onChangeDistancewithinPairs(e) {
      this.newIrrigation.pair_line_distance = e.value;
      this.validate();
    },
    onChangeDistanceBetweenDrippersIntoTheLineDouble(e) {
      this.newIrrigation.pair_drip_distance = e.value;
    },
    closePopUp() {
      this.onHidden();
    },
    followForm() {
      try {
        this.$f7.preloader.show();
        if (this.line === 'SIMPLE') {
          this.newIrrigation.pair_line_distance = 0;
        }
        this.createDatabaseIrrigation(this.newIrrigation);
        this.onHidden();
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onHidden() {
      this.setEnabledPopUpIrrigation(false);
    },
    ...mapActions('ProjectGreenHouse', ['setEnabledPopUpIrrigation', 'createDatabaseIrrigation']),
  },
};
</script>
<style lang="scss" scoped>
.imageIrrigation{
  content: url("../../../../static/img/imageIrrigation.png");
  width: 200px;
  height: auto;
}
.row {
  display: flex;
  .item-2 {
    margin: 1rem;
    max-width: 200px;
  }
}
</style>
